import script from "./BarnSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarnSection.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__